export const DEMOGRAPHIC_NAME_SORT_ORDER: Record<string, string[]> = {
  age: [
    'gb_15-24',
    '18-24',
    '18-29',
    'gb_25-34',
    '25-34',
    '30-39',
    'gb_35-44',
    '35-44',
    '40-49',
    '45-49',
    'gb_45-54',
    '50-54',
    '50-59',
    '55-59',
    'gb_55-64',
    '60-64',
    '60-69',
    '65-69',
    '65+',
    'gb_65+',
  ],
  country: ['gb_england', 'gb_scotland', 'gb_wales'],
  household_income: [
    'income_low',
    'income_lower_middle',
    'income_middle',
    'income_upper_middle',
    'income_high',
  ],
  education: [
    'gb_doctorate',
    'gb_post-secondary_education',
    'gb_secondary_education',
    'gb_primary_education',
    'gb_no_education',
    'gb_unknown_education',
  ],
  social_classification: [
    'gb_social_a',
    'gb_social_b',
    'gb_social_c1',
    'gb_social_c2',
    'gb_social_d',
    'gb_social_e',
  ],
  race: ['african-american', 'asian', 'white', 'other'],
  generation: [
    'gen-z',
    'gb_gen-z',
    'gen-y',
    'gb_gen-y',
    'gen-x',
    'gb_gen-x',
    'baby-boomers',
    'gb_baby-boomers',
  ],
};

export const sortDemographicsByPredefinedNameOrder = <T extends { id: string }>(
  items: T[],
  categoryId: string | undefined,
  sortedByName: boolean
): T[] => {
  if (!sortedByName || !categoryId) return items;

  const order = DEMOGRAPHIC_NAME_SORT_ORDER[categoryId];
  if (!order) return items;

  return [...items].sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
};
